export default () => ({
  isActive: false,
  isShow: false,
  isShowPrice: false,
  isShowProfile: false,
  covenants: [],
  graduations: {},
  professionalProfilePublic: [],
  crm: null,
  uf: null,
  cnpj: null,
  totalAgendas: null,
  totalAgendasSchedules: null,
  totalProfessional: null,
  operatorCovenant: null,
  isOpen: false,
  noProfilePublic: false,
  loading: false,
  text: 'Aguarde Processando...',
  dark: false,
  classes: null,
  background: null,
  customLoader: null
})



// WEBPACK FOOTER //
// ./src/app/patient/profile-company-professional/gadget/resources/data.js